import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // remove comment if yu needed
import app from '../../main'
import Crud from '../crud'
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'

const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('ProjectsDashboard', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  project: [],
  filterManufacturing: [],
  manufacturings: [],
  purchaseOrders: [],
  productionStatus: {},
  productionAreas: {},
  payments: [],
  paymentsUsd: [],
  paymentsMxn: [],
  invoicesPurchaseOrder: [],
  invoicesPurchaseOrderUsd: [],
  invoicesPurchaseOrderMxn: []
}

const mutations = {
  ...crud.mutations,
  SET_RECORD_MANUFACTURING (state, payload) {
    state.manufacturings = payload.data
  },
  UPDATE_MANUFACTURING (state, payload) {
    const idx = state.manufacturings.findIndex(u => u.id === payload.id)
    if (idx >= 0) {
      Vue.set(state.manufacturings, idx, payload)
    }
  },
  SET_PURCHASE_ORDER_CATALOG (state, payload) {
    state.invoicesPurchaseOrder = payload.invoicesPurchaseOrder
    state.invoicesPurchaseOrderUsd = payload.invoicesPurchaseOrderUsd
    state.invoicesPurchaseOrderMxn = payload.invoicesPurchaseOrderMxn
    state.payments = payload.payments
    state.paymentsMxn = payload.paymentsMxn
    state.paymentsUsd = payload.paymentsUsd
  },
  SET_RECORD_PROJECT (state, payload) {
    state.project = payload
  },
  SET_FILTER_MANUFACTURING (state, payload) {
    state.filterManufacturing = payload
  },
  SET_PRODUCTION_STATUS (state, payload) {
    state.productionStatus = payload.data
  },
  SET_PRODUCTION_AREA (state, payload) {
    state.productionAreas = payload.data
  }
}

const actions = {
  ...crud.actions,
  async loadProject ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects/${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORD_PROJECT', response.data.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadPurcharseOrders ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects/${payload.id}/customer-orders`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PURCHASE_ORDER_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadRecordsManufacture ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`customer-purchase-order-details?page=${payload.page}${state.filterManufacturing}&where_relation=${payload.id},purchase_order.project_id&${payload.param}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.products', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORD_MANUFACTURING', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilterManufacture ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_MANUFACTURING', filter)
  },
  clearFilterManufacture ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_MANUFACTURING', filter)
  },
  setLoaderVisible ({ commit }, payload) {
    commit('Quotations/SET_LOADER_VISIBLE', payload, { root: true })
  },
  loadProductionStatus ({ dispatch }, payload) {
    dispatch('Manufacturings/loadProductionStatus', payload, { root: true })
  },
  updateStatus ({ dispatch }, payload) {
    dispatch('Manufacturings/updateStatus', payload, { root: true })
  },
  loadProductionArea ({ dispatch }, payload) {
    dispatch('Manufacturings/loadProductionArea', payload, { root: true })
  }
}

const getters = {
  ...crud.getters,
  project: state => state.project,
  manufacturings: state => state.manufacturings,
  filterManufacturing: state => state.filterManufacturing,
  paymentsUsd: state => state.paymentsUsd,
  paymentsMxn: state => state.paymentsMxn,
  payments: state => state.payments,
  purchaseOrders: state => state.purchaseOrders,
  invoicesPurchaseOrderUsd: state => state.invoicesPurchaseOrderUsd,
  invoicesPurchaseOrderMxn: state => state.invoicesPurchaseOrderMxn,
  invoicesPurchaseOrder: state => state.invoicesPurchaseOrder,
  productionStatus: (state, getters, rootState, rootGetters) => rootGetters['Manufacturings/productionStatus'],
  productionAreas: (state, getters, rootState, rootGetters) => rootGetters['Manufacturings/productionAreas'],
  loader: (state, getters, rootState, rootGetters) => rootGetters['Quotations/loader']
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
